import * as React from "react";
import useApi from "@/hooks/useApi";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";

export default function Index() {
  const [saving, setSaving] = React.useState(false);
  const [companyName, setCompanyName] = React.useState("");
  const api = useApi();

  async function handleCreate() {
    if (!companyName.trim()) return;
    setSaving(true);
    try {
      await api.admin.post("api/kb/tenants", { companyName });
      window.location.href = "/kb/articles";
    } catch (err) {
      console.error("Failed to create KB tenant:", err);
      setSaving(false);
    }
  }

  return (
    <div className="p-6 max-w-lg mx-auto">
      <div className="text-center mb-8">
        <i className="fa fa-book text-5xl text-blue-500 mb-4" />
        <h1 className="text-2xl font-semibold text-slate-800">
          Set Up Your Knowledge Base
        </h1>
        <p className="text-sm text-slate-500 mt-2">
          Create a public knowledge base where your customers can find answers
          to common questions. Articles can also be used by your AI chatbot.
        </p>
      </div>

      <div className="bg-white rounded-lg border shadow-sm p-6">
        <form onSubmit={(e) => { e.preventDefault(); handleCreate(); }}>
          <div className="mb-4">
            <label htmlFor="company-name" className="block text-sm font-medium text-slate-700 mb-1">
              Company Name
            </label>
            <input
              type="text"
              id="company-name"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter your company name"
              autoFocus
              value={companyName}
              onChange={(e) => setCompanyName(e.currentTarget.value)}
            />
            <p className="text-xs text-slate-400 mt-1">
              This will be displayed as the title of your knowledge base
            </p>
          </div>
          <PrimaryBlueButton
            label={saving ? "Creating..." : "Create Knowledge Base"}
            disabled={saving || !companyName.trim()}
            onClick={() => handleCreate()}
          />
        </form>
      </div>
    </div>
  );
}
